__turbopack_context__.v({
  "root": "LabelledRadio-module__wp4cMq__root",
});
